import { navLinks } from '../data.ts'
// import { ArrowUpRight } from 'lucide-react'
import React from 'react'

// const socials = ['Twitter', 'LinkedIn', 'GitHub', 'Dribbble']

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-ink-950">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#home" className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-xl bg-gradient-to-br from-brand-400 to-brand-600 text-ink-950">
              <img
        src="/logo.png"
        alt="Logo"
        className="h-full w-full object-contain"
      />
              </span>
              <span className="font-display text-xl font-bold tracking-tight text-white">Raag Technologies</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              A web development studio crafting fast, beautiful, dynamic websites that help modern businesses grow.
            </p>
            {/* <div className="mt-5 flex flex-wrap gap-2">
              {socials.map((s) => (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                  key={s}
                  href="#"
                  className="inline-flex items-center gap-1 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-medium text-slate-300 transition-colors hover:border-brand-500/40 hover:text-white"
                >
                  {s}
                  <ArrowUpRight size={12} />
                </a>
              ))}
            </div> */}
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wide text-slate-300">Navigate</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-slate-400 transition-colors hover:text-brand-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wide text-slate-300">Get in touch</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
              <li>
              info@raagtechnologies.com</li>
              <li>+91 82000 71242</li>
              <li>+1 (289) 552-5748</li>
              <li>Gujrat, India</li>
            </ul>
            <a
              href="#contact"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand-500 px-5 py-2.5 text-sm font-semibold text-ink-950 transition-transform hover:scale-[1.03]"
            >
              Start a project
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Raag. All rights reserved.</p>
          <p className="text-xs text-slate-500">Built with React, Tailwind & the MERN stack.</p>
        </div>
      </div>
    </footer>
  )
}
